import metaAdsTranslations from "./metaAdsTranslations";
// Copy for Analytics (/admin/analytics/*). Albanian first, English mirrors it.
// Merged into the global translations under the `analytics` namespace.
//
// Wording rules: "revenue" is what customers paid for merchandise after
// discounts; "net" is after refunds. Anything derived from cost is always
// called "estimated" because only today's cost is recorded.

const tx = (sq, en) => ({ sq, en });

const analyticsTranslations = {
  ...metaAdsTranslations,
  "tab_traffic": tx("Inteligjenca e trafikut", "Traffic intelligence"),
  "traffic_subtitle": tx("Trafiku dhe interesi në dyqan · Google Analytics 4", "Website traffic and shopping interest · Google Analytics 4"),
  "traffic_days": tx("{days} ditët e fundit", "Last {days} days"),
  "traffic_completedDays": tx("Periudhat përfundojnë dje sipas zonës kohore të GA4. Maksimumi 180 ditë.", "Presets end yesterday in the GA4 reporting timezone. Maximum 180 days."),
  "traffic_activeUsers": tx("Përdorues aktivë", "Active users"),
  "traffic_activeUsers_help": tx("Përdorues të dallueshëm aktivë sipas GA4; nuk janë të gjithë vizitorët unikë.", "Distinct active users as defined by GA4; this is not all unique visitors."),
  "traffic_sessions": tx("Sesione", "Sessions"),
  "traffic_sessions_help": tx("Sesione që filluan në periudhën e zgjedhur.", "Sessions that began during the selected period."),
  "traffic_newUsers": tx("Përdorues të rinj", "New users"),
  "traffic_newUsers_help": tx("Përdorues me ngjarjen first_visit ose first_open.", "Users with a first_visit or first_open event."),
  "traffic_engagementRate": tx("Shkalla e angazhimit", "Engagement rate"),
  "traffic_engagementRate_help": tx("Sesione të angazhuara pjesëtuar me të gjitha sesionet.", "Engaged sessions divided by all sessions."),
  "traffic_view_item": tx("Shikime produktesh", "Product view events"),
  "traffic_view_item_help": tx("Numri i ngjarjeve view_item; shikimet e përsëritura përfshihen.", "Count of view_item events; includes repeat views."),
  "traffic_purchase": tx("Ngjarje blerjeje në faqe", "Website purchase events"),
  "traffic_purchase_help": tx("Ngjarje purchase të gjurmuara kur bëhet porosia. Nuk dëshmojnë pagesën ose dorëzimin.", "Tracked purchase events on order placement. These do not verify payment or delivery."),
  "traffic_add_to_cart": tx("Shtime në shportë", "Add-to-cart events"),
  "traffic_view_cart": tx("Shikime shporte", "Cart view events"),
  "traffic_begin_checkout": tx("Fillime të porosisë", "Checkout start events"),
  "traffic_freshness": tx("Marrë më {at} · Memorje 15 minuta", "Fetched {at} · Cached for 15 minutes"),
  "traffic_warning_includes_today": tx("Dita e sotme është e paplotë. Krahasimi me periudhën e kaluar është çaktivizuar.", "Today is incomplete. Previous-period comparisons are disabled."),
  "traffic_warning_processing_delay": tx("GA4 mund të përpunojë dhe ndryshojë të dhënat e fundit për 24–48 orë. Koha e marrjes nuk garanton përfundimin e përpunimit.", "GA4 may process and revise recent data for 24–48 hours. Fetch time does not guarantee processing is complete."),
  "traffic_warning_tracking_coverage": tx("Pëlqimi, bllokuesit dhe ndryshimet në gjurmim ndikojnë mbulimin. Mungesa e ngjarjeve nuk dëshmon mungesë të aktivitetit real.", "Consent, blockers and tracking changes affect coverage. Missing events do not prove an absence of real activity."),
  "traffic_warning_partial": tx("Disa raporte janë të paplota, të kufizuara ose të padisponueshme. Kontrolloni shënimet e seksioneve.", "Some reports are incomplete, limited or unavailable. Check section notices."),
  "traffic_noData": tx("Nuk ka të dhëna të raportuara", "No reported data"),
  "traffic_noDataBody": tx("GA4 u përgjigj me sukses pa aktivitet për këtë periudhë. Provoni data të tjera.", "GA4 responded successfully without activity for this period. Try another range."),
  "traffic_trend": tx("Trendi i trafikut", "Traffic trend"),
  "traffic_dailyNote": tx("Vlera ditore. Përdoruesit aktivë nuk duhet të mblidhen ndërmjet ditëve.", "Daily values. Active users must not be summed across days."),
  "traffic_acquisition": tx("Burimet e sesioneve", "Session acquisition"),
  "traffic_acquisitionNote": tx("100 rreshtat kryesorë sipas sesioneve. Burimi dhe mediumi janë të sesionit. Trafiku social nuk është domosdoshmërisht me pagesë.", "Top 100 rows by sessions. Session-scoped source and medium. Social traffic is not necessarily paid."),
  "traffic_source": tx("Burimi / kanali", "Source / channel"),
  "traffic_engagedSessions": tx("Sesione të angazhuara", "Engaged sessions"),
  "traffic_activity": tx("Aktiviteti i blerjeve", "Shopping activity"),
  "traffic_activityNote": tx("Vëllime të pavarura ngjarjesh, jo hinkë e verifikuar përdoruesish ose sesionesh. Shiritat nuk matin konvertimin ose braktisjen.", "Independent event volumes, not a verified user or session funnel. Bars do not measure conversion or abandonment."),
  "traffic_products": tx("Interesi për produktet", "Product interest"),
  "traffic_productsNote": tx("25 produktet kryesore sipas njësive të shikuara. Njësitë e artikujve dallojnë nga numri i ngjarjeve.", "Top 25 products by units viewed. Item quantities differ from event counts."),
  "traffic_product": tx("Produkti", "Product"),
  "traffic_itemsViewed": tx("Njësi të shikuara", "Units viewed"),
  "traffic_itemsAddedToCart": tx("Njësi në shportë", "Units added to cart"),
  "traffic_itemsPurchased": tx("Njësi të porositura", "Units ordered"),
  "traffic_noRows": tx("Nuk ka rreshta të raportuar për këtë periudhë.", "No rows reported for this period."),
  "traffic_devices": tx("Pajisjet", "Devices"),
  "traffic_device": tx("Pajisja", "Device"),
  "traffic_device_mobile": tx("Telefon", "Mobile"),
  "traffic_device_desktop": tx("Kompjuter", "Desktop"),
  "traffic_device_tablet": tx("Tablet", "Tablet"),
  "traffic_device_smart tv": tx("TV inteligjent", "Smart TV"),
  "traffic_device_other": tx("Tjetër", "Other"),
  "traffic_insights": tx("Vëzhgime", "Observations"),
  "traffic_insightsNote": tx("Krahasime të llogaritura nga të dhënat e disponueshme; nuk shpjegojnë shkakun.", "Computed comparisons from available data; they do not explain causality."),
  "traffic_insight_sessions_change": tx("Ndryshimi i sesioneve nga periudha e kaluar: {value}.", "Sessions changed by {value} versus the previous period."),
  "traffic_insight_instagram_leads": tx("Instagram solli {value} sesione më shumë se Facebook në këtë periudhë.", "Instagram brought {value} more sessions than Facebook during this period."),
  "traffic_noInsights": tx("Nuk ka të dhëna të mjaftueshme për krahasime të besueshme.", "Insufficient data for reliable comparisons."),
  "traffic_averageEngagement": tx("Angazhimi mesatar për sesion", "Average engagement per session"),
  "traffic_seconds": tx("sekonda", "seconds"),
  "traffic_pageViews": tx("Shikime faqesh", "Page views"),
  "traffic_salesComparison": tx("Interesi online dhe shitjet e regjistruara", "Online interest and recorded sales"),
  "traffic_salesDisclaimer": tx("Vlera GA4 përfaqëson porosi të gjurmuara, jo pagesa, dorëzime ose fitim. Shitjet neto përfshijnë të gjitha kanalet nga regjistri i brendshëm, me zonën kohore të dyqanit. Datat e porosive dhe shitjeve mund të ndryshojnë. Këto shifra nuk rakordohen drejtpërdrejt.", "GA4 value represents tracked orders, not payments, deliveries or profit. Net sales cover all channels from the internal ledger in the shop timezone. Order and sale dates can differ. These figures do not directly reconcile."),
  "traffic_orderValue": tx("Vlera e porosive të gjurmuara nga GA4", "GA4-tracked order value"),
  "traffic_ledgerSales": tx("Shitje neto të regjistruara · të gjitha kanalet", "Recorded net sales · all channels"),
  "traffic_state_not_configured": tx("Lidhja me GA4 nuk është konfiguruar", "GA4 connection is not configured"),
  "traffic_state_permission_denied": tx("GA4 refuzoi qasjen ose API është i çaktivizuar", "GA4 access denied or API disabled"),
  "traffic_state_unauthorized": tx("Autentikimi me Google dështoi", "Google authentication failed"),
  "traffic_state_rate_limited": tx("Kuota e GA4 është arritur. Provoni më vonë.", "GA4 quota reached. Try again later."),
  "traffic_state_unavailable": tx("GA4 përkohësisht i padisponueshëm", "GA4 temporarily unavailable"),
  "traffic_state_partial": tx("Raporti është i kufizuar, i kampionuar ose i paplotë.", "Report is limited, sampled or incomplete."),
  "traffic_connectionHelp": tx("Administratori duhet të kontrollojë konfigurimin e serverit dhe qasjen vetëm për lexim në GA4. Nuk shfaqen të dhëna provë.", "An administrator must check server configuration and read-only GA4 access. No sample figures are displayed."),
  salesIntelligenceTitle: tx("Inteligjenca e shitjeve", "Sales intelligence"),
  freshnessLabel: tx("Llogaritur më {at} · Memoria deri në {seconds}s", "Calculated {at} · Cached up to {seconds}s"),
  refreshData: tx("Rifresko", "Refresh"),
  costCoverageTitle: tx("Besueshmëria e fitimit", "Profit confidence"),
  costCoverageHint: tx("Fitimi përfshin vetëm linjat me kosto. Transporti, reklamat dhe shpenzimet operative nuk përfshihen.", "Profit includes only lines with costs. Delivery, advertising and operating expenses are excluded."),
  costBasis: tx("Baza e kostos", "Cost basis"),
  salesCostCoverage: tx("Shitjet me kosto", "Sales with cost"),
  recordedSalesCoverage: tx("Kosto e regjistruar në shitje", "Recorded sales cost"),
  returnCostCoverage: tx("Kthimet me kosto", "Returns with cost"),
  recordedReturnCoverage: tx("Kosto e regjistruar në kthime", "Recorded return cost"),
  uncoveredAmounts: tx("Pa kosto: {sales} në shitje · {returns} në kthime.", "Without cost: {sales} of sales · {returns} of returns."),
  reconciliationTitle: tx("Porositë e dorëzuara pa shitje", "Delivered orders without sales"),
  reconciliationHint: tx("Të gjitha rastet e pazgjidhura, pavarësisht periudhës së zgjedhur. Nuk përfshihen në të ardhurat.", "All unresolved cases, regardless of selected dates. Excluded from revenue."),
  reconciliationSummary: tx("{count} porosi · {value} mallra ende të paregjistruara si shitje", "{count} orders · {value} merchandise not yet recorded as sales"),
  reconciliationClear: tx("Asnjë porosi e dorëzuar nuk pret regjistrimin e shitjes.", "No delivered orders are awaiting a completed sale."),
  reconciliationLimit: tx("Shfaqen {shown} nga {total}, më të vjetrat të parat. Kontrolloji te Porositë; kjo faqe nuk krijon shitje.", "Showing {shown} of {total}, oldest first. Review in Orders; this page does not create sales."),
  orderNumber: tx("Porosia", "Order"),
  deliveredAt: tx("Dorëzuar më", "Delivered"),
  merchandiseValue: tx("Vlera e mallit", "Merchandise value"),
  bestSellingTitle: tx("Produktet më të shitura", "Best-selling products"),
  bestSellingHint: tx("5 produktet kryesore sipas copëve neto: të shitura − të kthyera.", "Top 5 by net units: sold − returned."),
  categoryBasisHint: tx("5 kategoritë kryesore sipas të ardhurave neto. Përdoret kategorizimi aktual.", "Top 5 by net merchandise sales. Uses current category assignments."),
  salesChannelHint: tx("Shitjet neto sipas kanalit fillestar, përfshirë këmbimet dhe kthimet. Nuk është atribuim reklamash.", "Net sales by originating channel, including exchanges and returns. This is not ad attribution."),
  channel_website: tx("Porositë nga website", "Website orders"),
  channel_assisted: tx("Porositë e asistuara", "Assisted orders"),
  note_return_cost_partial: tx("Kthimet me vlerë {amount} nuk kanë kosto. Fitimi përjashton këto linja.", "Returns worth {amount} have no cost. Profit excludes these lines."),
  // ── Shell ────────────────────────────────────────────────
  eyebrow: tx("Analitika", "Analytics"),
  pageTitle: tx("Performanca e biznesit", "Business performance"),
  pageSubtitle: tx(
    "Të ardhurat, fitimi bruto, produktet dhe stoku — nga shitjet reale të dyqanit dhe online.",
    "Revenue, gross profit, products and stock — from real store and online sales."
  ),
  tab_overview: tx("Përmbledhje", "Overview"),
  tab_sales: tx("Shitjet", "Sales"),
  tab_products: tx("Produktet", "Products"),
  tab_inventory: tx("Stoku", "Inventory"),
  tab_profitability: tx("Fitimi", "Profitability"),
  tab_insights: tx("Vëzhgime", "Insights"),
  tab_reports: tx("Raportet", "Reports"),
  sectionsLabel: tx("Seksionet e analitikës", "Analytics sections"),

  // ── Range ────────────────────────────────────────────────
  range: tx("Periudha", "Period"),
  preset_7d: tx("7 ditë", "7 days"),
  preset_30d: tx("30 ditë", "30 days"),
  preset_90d: tx("90 ditë", "90 days"),
  preset_thisMonth: tx("Ky muaj", "This month"),
  preset_lastMonth: tx("Muaji i kaluar", "Last month"),
  preset_thisQuarter: tx("Ky tremujor", "This quarter"),
  preset_ytd: tx("Që nga janari", "Year to date"),
  preset_12m: tx("12 muaj", "12 months"),
  preset_custom: tx("E zgjedhur", "Custom"),
  dateFrom: tx("Nga", "From"),
  dateTo: tx("Deri", "To"),
  apply: tx("Zbato", "Apply"),
  granularity: tx("Grupimi", "Group by"),
  g_day: tx("Ditë", "Day"),
  g_week: tx("Javë", "Week"),
  g_month: tx("Muaj", "Month"),
  rangeError_invalid: tx("Zgjidh data të vlefshme.", "Choose valid dates."),
  rangeError_order: tx("Data e fillimit duhet të jetë para datës së mbarimit.", "The start date must be before the end date."),
  rangeError_tooLong: tx("Periudha mund të jetë deri në 2 vjet.", "The period can be up to 2 years."),
  comparedTo: tx("krahasuar me {from} – {to}", "compared with {from} – {to}"),
  periodLabel: tx("{from} – {to} · {days} ditë", "{from} – {to} · {days} days"),
  timezoneNote: tx("Ditët llogariten sipas orës së Prishtinës.", "Days follow Prishtina time."),

  // ── States ───────────────────────────────────────────────
  loading: tx("Duke ngarkuar të dhënat…", "Loading data…"),
  loadError: tx("Të dhënat nuk u ngarkuan.", "Could not load the data."),
  retry: tx("Provo përsëri", "Try again"),
  emptyTitle: tx("Asnjë shitje në këtë periudhë", "No sales in this period"),
  emptyBody: tx("Zgjidh një periudhë tjetër ose kontrollo më vonë.", "Choose another period or check back later."),
  unavailable: tx("Nuk ka të dhëna", "Not available"),
  noPrevious: tx("pa krahasim", "no comparison"),
  restrictedTitle: tx("Vetëm për pronarin dhe administratorin", "Owner and admin only"),
  restrictedBody: tx(
    "Kostoja, fitimi bruto dhe marzhi shihen vetëm nga pronari dhe administratorët.",
    "Cost, gross profit and margin are visible to owners and admins only."
  ),
  costHidden: tx("Kosto e fshehur", "Cost hidden"),
  estimated: tx("e vlerësuar", "estimated"),
  basis_recorded: tx("kosto e regjistruar", "recorded cost"),
  basis_mixed: tx("pjesërisht e vlerësuar", "partly estimated"),
  basis_estimated: tx("e vlerësuar", "estimated"),
  basisShort_estimated: tx("vlerës.", "est."),
  basisShort_mixed: tx("pjes. vlerës.", "part est."),
  exportCsv: tx("Shkarko CSV", "Export CSV"),
  exporting: tx("Duke përgatitur…", "Preparing…"),
  exportError: tx("Eksporti nuk u krye. Provo përsëri.", "The export failed. Please try again."),
  showTable: tx("Shfaq tabelën", "Show table"),
  hideTable: tx("Fshih tabelën", "Hide table"),
  previousPeriod: tx("Periudha e mëparshme", "Previous period"),
  currentPeriod: tx("Kjo periudhë", "This period"),
  page: tx("Faqja {page} nga {total}", "Page {page} of {total}"),
  next: tx("Tjetra", "Next"),
  previous: tx("Mbrapa", "Previous"),
  rowsCount: tx("{count} rreshta", "{count} rows"),
  search: tx("Kërko produkt, SKU ose markë", "Search product, SKU or brand"),
  uncategorised: tx("Pa kategori", "Uncategorised"),
  notSet: tx("Pa vlerë", "Not set"),
  all: tx("Të gjitha", "All"),
  howCalculated: tx("Si llogaritet", "How it is calculated"),

  // ── KPIs (label + formula tooltip) ───────────────────────
  kpi_totalRevenue: tx("Të ardhurat", "Total revenue"),
  kpi_totalRevenue_help: tx(
    "Shuma që klientët paguan për mallin pas zbritjeve, në shitjet e përfunduara (dyqan + porositë e dorëzuara). Pa transportin.",
    "What customers paid for merchandise after discounts on completed sales (store + delivered orders). Excludes delivery fees."
  ),
  kpi_netRevenue: tx("Të ardhurat neto", "Net merchandise sales"),
  kpi_netRevenue_help: tx("Të ardhurat − rimbursimet e kthimeve të përfunduara në këtë periudhë.", "Revenue − refunds for returns completed in this period."),
  kpi_grossProfit: tx("Fitimi bruto", "Gross profit"),
  kpi_grossProfit_help: tx(
    "Të ardhurat neto − kostoja e mallit të shitur. Kostoja është ajo e regjistruar në momentin e shitjes; për shitjet e vjetra pa kosto të regjistruar përdoret kostoja aktuale e variantit dhe shifra shënohet si e vlerësuar.",
    "Net revenue − cost of goods sold. Cost is the cost recorded at the moment of sale; for older sales without a recorded cost the variant's current cost is used and the figure is marked estimated."
  ),
  kpi_grossMargin: tx("Marzhi bruto", "Gross margin"),
  kpi_grossMargin_help: tx("Fitimi bruto ÷ të ardhurat neto pozitive të linjave me kosto. Nuk paraqitet kur ato janë zero ose negative.", "Gross profit ÷ positive net revenue of covered lines. Unavailable for zero or negative covered net revenue."),
  kpi_salesCount: tx("Shitjet", "Fulfilled transactions"),
  kpi_salesCount_help: tx("Shitjet e përfunduara, pa shitjet zëvendësuese të këmbimeve.", "Completed sales, excluding exchange replacement sales."),
  kpi_averageOrderValue: tx("Vlera mesatare", "Average order value"),
  kpi_averageOrderValue_help: tx("Të ardhurat e shitjeve ÷ numri i shitjeve (pa këmbimet).", "Sales revenue ÷ number of sales (exchanges excluded)."),
  kpi_unitsSold: tx("Copë të shitura", "Units sold"),
  kpi_unitsSold_help: tx("Të gjitha copat në shitjet e përfunduara, përfshirë zëvendësimet.", "All units on completed sales, including replacements."),
  kpi_refunds: tx("Rimbursimet", "Refunds & returns"),
  kpi_refunds_help: tx("Shuma e kthyer klientëve për kthimet e përfunduara në këtë periudhë, sipas datës së kthimit.", "Money refunded for returns completed in this period, by return date."),
  returnsDetail: tx("{count} kthime · {units} copë", "{count} returns · {units} units"),

  // ── Overview ─────────────────────────────────────────────
  revenueTrend: tx("Të ardhurat në kohë", "Revenue over time"),
  revenueTrendHint: tx("Vija e ndërprerë është periudha e mëparshme e njëjtë.", "The dashed line is the equal previous period."),
  salesVolume: tx("Numri i shitjeve", "Sales volume"),
  byChannel: tx("Sipas kanalit", "By sales channel"),
  byCategory: tx("Sipas kategorisë", "By category"),
  channel_store: tx("Dyqani fizik", "Physical store"),
  channel_online: tx("Online (porositë e dorëzuara)", "Online (delivered orders)"),
  channel_STORE: tx("Dyqani", "Store"),
  channel_WEBSHOP: tx("Webshop", "Webshop"),
  channel_INSTAGRAM: tx("Instagram", "Instagram"),
  channel_FACEBOOK: tx("Facebook", "Facebook"),
  channel_PHONE: tx("Telefon", "Phone"),
  channel_OTHER: tx("Tjetër", "Other"),
  channel_UNSPECIFIED: tx("Pa kanal", "Unspecified"),
  onlineBreakdown: tx("Kanalet e kontaktit të porosive", "Order contact channels"),
  revenue: tx("Të ardhurat", "Revenue"),
  netRevenue: tx("Neto", "Net"),
  share: tx("Pjesa", "Share"),
  units: tx("Copë", "Units"),
  sales: tx("Shitje", "Sales"),

  // ── Data notes ───────────────────────────────────────────
  note_cost_partial: tx(
    "Fitimi përfshin vetëm linjat me kosto të njohura. Kontrollo mbulimin e kostos për shitjet dhe kthimet.",
    "Profit includes only lines with known costs. Review sales and return cost coverage."
  ),
  note_cost_unavailable: tx(
    "Kostot e shitjeve ose kthimeve në këtë periudhë mungojnë, prandaj fitimi nuk mund të llogaritet.",
    "Costs are unavailable for the sales or returns in this period, so profit cannot be calculated."
  ),
  note_cost_current_estimate: tx(
    "Disa kosto të shitjeve ose kthimeve përdorin koston aktuale të variantit. Fitimi mund të ndryshojë nëse këto kosto ndryshojnë.",
    "Some sale or return costs use current variant costs. Profit may change when those costs change."
  ),
  note_delivered_without_sale: tx(
    "{count} porosi të dorëzuara ({amount}) nuk u regjistruan si shitje dhe nuk përfshihen.",
    "{count} delivered orders ({amount}) were not recorded as sales and are not included."
  ),
  note_shipping_fees_excluded: tx(
    "Tarifat e transportit ({amount}) nuk llogariten si të ardhura.",
    "Delivery fees ({amount}) are not counted as revenue."
  ),
  note_turnover_current_stock: tx(
    "Qarkullimi përdor stokun aktual, sepse stoku historik nuk ruhet.",
    "Turnover uses current stock because historical stock levels are not recorded."
  ),
  note_receipt_dates: tx(
    "{unknown} variante në stok nuk kanë datë të verifikuar pranimi; mosha e tyre shfaqet si e panjohur.",
    "{unknown} in-stock variants have no verified receipt date; their age shows as unknown."
  ),

  // ── Sales ────────────────────────────────────────────────
  grossSales: tx("Shitjet bruto", "Gross sales"),
  discounts: tx("Zbritjet", "Discounts"),
  refunds: tx("Rimbursimet", "Refunds"),
  discountRate: tx("Norma e zbritjes", "Discount rate"),
  refundRate: tx("Norma e rimbursimit", "Refund rate"),
  unitsPerTransaction: tx("Copë për shitje", "Units per sale"),
  exchanges: tx("Këmbime", "Exchanges"),
  storeVsOnline: tx("Dyqani kundrejt online", "Store vs online"),
  salesTrend: tx("Shitjet në kohë", "Sales over time"),
  weekdayTitle: tx("Të ardhurat sipas ditës së javës", "Revenue by weekday"),
  weekdayHint: tx("Mesatarja për çdo ditë të tillë në periudhë.", "Average per occurrence of that weekday in the period."),
  hourTitle: tx("Të ardhurat sipas orës", "Revenue by hour"),
  hourHint: tx(
    "Vetëm shitjet në dyqan: ora e shitjeve online është ora e konfirmimit të dorëzimit, jo e blerjes.",
    "Store sales only: an online sale's time is when delivery was confirmed, not when it was bought."
  ),
  peakDays: tx("Ditët më të mira", "Peak sales days"),
  paymentMethods: tx("Mënyra e pagesës (dyqan)", "Payment method (store)"),
  method_CASH: tx("Kesh", "Cash"),
  method_CARD: tx("Kartelë", "Card"),
  method_BANK: tx("Bankë", "Bank"),
  method_UNKNOWN: tx("E panjohur", "Unknown"),
  ordersTitle: tx("Porositë online", "Online orders"),
  ordersHint: tx("Porositë e krijuara në periudhë. Vetëm porositë e dorëzuara bëhen shitje.", "Orders created in the period. Only delivered orders become sales."),
  ordersCreated: tx("Të krijuara", "Created"),
  status_PENDING: tx("Në pritje", "Pending"),
  status_CONFIRMED: tx("Të konfirmuara", "Confirmed"),
  status_DELIVERED: tx("Të dorëzuara", "Delivered"),
  status_CANCELLED: tx("Të anuluara", "Cancelled"),
  status_RETURNED_TO_SENDER: tx("Të kthyera nga postieri", "Returned to sender"),
  cancellationRate: tx("Norma e anulimit", "Cancellation rate"),
  openPipeline: tx("Porosi të hapura tani", "Open orders now"),
  deliveryFees: tx("Tarifat e transportit", "Delivery fees"),
  reason_CUSTOMER_CANCELLED: tx("Klienti anuloi", "Customer cancelled"),
  reason_CUSTOMER_UNREACHABLE: tx("Klienti nuk u gjet", "Customer unreachable"),
  reason_INVALID_DATA: tx("Të dhëna të pasakta", "Invalid data"),
  reason_STOCK_ISSUE: tx("Problem me stokun", "Stock issue"),
  reason_OTHER: tx("Tjetër", "Other"),
  reason_UNSPECIFIED: tx("Pa arsye", "No reason"),
  transactions: tx("Shitjet e periudhës", "Sales in this period"),
  col_sale: tx("Shitja", "Sale"),
  col_date: tx("Data", "Date"),
  col_channel: tx("Kanali", "Channel"),
  col_payment: tx("Pagesa", "Payment"),
  col_units: tx("Copë", "Units"),
  col_discount: tx("Zbritja", "Discount"),
  col_total: tx("Totali", "Total"),
  col_refunded: tx("Rimbursuar", "Refunded"),
  exchangeTag: tx("Këmbim", "Exchange"),

  // ── Products ─────────────────────────────────────────────
  productsTitle: tx("Performanca e produkteve", "Product performance"),
  productsHint: tx(
    "Renditjet sipas fitimit përfshijnë vetëm produktet me kosto të plotë; normat renditen pas të paktën {min} copëve.",
    "Profit rankings include only products with complete cost; rates rank after at least {min} units."
  ),
  sort: tx("Rendit sipas", "Sort by"),
  sort_netRevenue: tx("Të ardhurave neto", "Net revenue"),
  sort_netUnits: tx("Copëve neto", "Net units"),
  sort_grossProfit: tx("Fitimit bruto", "Gross profit"),
  sort_grossMargin: tx("Marzhit", "Gross margin"),
  sort_returnRate: tx("Normës së kthimit", "Return rate"),
  sort_sellThrough: tx("Shitjes së stokut", "Sell-through"),
  sort_onHand: tx("Stokut", "Stock on hand"),
  sort_title: tx("Emrit", "Name"),
  direction_desc: tx("Më të lartat", "Highest first"),
  direction_asc: tx("Më të ulëtat", "Lowest first"),
  category: tx("Kategoria", "Category"),
  family: tx("Lloji", "Type"),
  family_shoes: tx("Këpucë", "Footwear"),
  family_textile: tx("Tekstil", "Textile"),
  family_accessories: tx("Aksesorë", "Accessories"),
  performance: tx("Shitjet", "Sales"),
  performance_all: tx("Të gjitha", "All"),
  performance_selling: tx("Me shitje", "With sales"),
  performance_no_sales: tx("Pa shitje në periudhë", "No sales in period"),
  col_product: tx("Produkti", "Product"),
  col_netUnits: tx("Copë neto", "Net units"),
  col_netRevenue: tx("Neto", "Net revenue"),
  col_profit: tx("Fitimi bruto", "Gross profit"),
  col_margin: tx("Marzhi", "Margin"),
  col_returnRate: tx("Kthime", "Returns"),
  col_sellThrough: tx("Shitja e stokut", "Sell-through"),
  col_onHand: tx("Në stok", "On hand"),
  col_lastSold: tx("Shitja e fundit", "Last sold"),
  sellThroughHelp: tx(
    "Copë të shitura ÷ (copë të shitura + stoku aktual). Përafrim: stoku historik nuk ruhet.",
    "Units sold ÷ (units sold + current stock). Approximation: historical stock is not recorded."
  ),
  returnRateHelp: tx("Copë të kthyera ÷ copë të shitura në periudhë.", "Units returned ÷ units sold in the period."),
  costIncompleteTag: tx("Kosto e paplotë", "Cost incomplete"),
  costMissingTag: tx("Pa kosto", "No cost"),
  lowVolumeTag: tx("Pak shitje", "Low volume"),
  openProduct: tx("Hap produktin", "Open product"),
  productsSummary: tx("{selling} me shitje · {none} pa shitje", "{selling} selling · {none} without sales"),
  breakdownsTitle: tx("Kategoritë, numrat dhe ngjyrat", "Categories, sizes and colours"),
  sizes: tx("Numrat", "Sizes"),
  colors: tx("Ngjyrat", "Colours"),
  families: tx("Llojet", "Types"),
  categories: tx("Kategoritë", "Categories"),
  change: tx("Ndryshimi", "Change"),
  variantsTitle: tx("Variantet", "Variants"),
  variantsHint: tx("Performanca për çdo ngjyrë dhe numër.", "Performance for every colour and size."),
  col_variant: tx("Varianti", "Variant"),

  // ── Inventory ────────────────────────────────────────────
  unitsOnHand: tx("Copë në stok", "Units in stock"),
  unitsOnHandHint: tx("{reserved} të rezervuara për porosi", "{reserved} reserved for orders"),
  costValue: tx("Vlera me kosto", "Value at cost"),
  costValueHelp: tx("Stoku × kostoja aktuale, vetëm për variantet me kosto.", "Stock × current cost, only for variants with a cost."),
  retailValue: tx("Vlera me çmim shitje", "Retail value"),
  retailValueHelp: tx("Stoku × çmimi aktual i shitjes.", "Stock × current selling price."),
  coverage: tx("mbulim {value}", "{value} coverage"),
  turnover: tx("Qarkullimi vjetor", "Annual turnover"),
  turnoverHelp: tx(
    "Copë të shitura në 90 ditët e fundit × 365/90 ÷ stoku aktual.",
    "Units sold in the last 90 days × 365/90 ÷ current stock."
  ),
  daysOfInventory: tx("{days} ditë stok", "{days} days of stock"),
  stockHealth: tx("Gjendja e stokut", "Stock health"),
  flag_low: tx("Stok i ulët", "Low stock"),
  flag_out: tx("Pa stok", "Out of stock"),
  flag_slow: tx("Lëvizje e ngadaltë", "Slow moving"),
  flag_dead: tx("Stok i ndenjur", "Dead stock"),
  flag_high_demand: tx("Kërkesë e lartë, stok i pakët", "High demand, low stock"),
  flag_in_stock: tx("Në stok", "In stock"),
  flag_all: tx("Të gjitha", "All"),
  flag_low_help: tx("Të disponueshme ≤ {threshold} copë.", "Available ≤ {threshold} units."),
  flag_dead_help: tx("Në stok, pa shitje dhe pa pranim në {days} ditët e fundit.", "In stock with no sale and no receipt in the last {days} days."),
  flag_slow_help: tx("Stoku mjafton për më shumë se 90 ditë me ritmin e 30 ditëve të fundit.", "Stock lasts more than 90 days at the last 30 days' pace."),
  flag_high_demand_help: tx("Të paktën 3 copë të shitura në 30 ditë dhe stok për ≤ 14 ditë.", "At least 3 units sold in 30 days and ≤ 14 days of stock left."),
  distribution: tx("Shpërndarja e stokut", "Stock distribution"),
  byProduct: tx("Sipas produktit", "By product"),
  bySize: tx("Sipas numrit", "By size"),
  byFamily: tx("Sipas llojit", "By type"),
  highDemandList: tx("Shiten shpejt, po mbarojnë", "Selling fast, running out"),
  lowStockList: tx("Stok i ulët", "Low stock"),
  deadStockList: tx("Vlera më e madhe e ndenjur", "Highest-value dead stock"),
  stockTable: tx("Stoku sipas variantit", "Stock by variant"),
  col_available: tx("Disponueshme", "Available"),
  col_reserved: tx("Rezervuar", "Reserved"),
  col_units30: tx("Shitur 30 ditë", "Sold 30 days"),
  col_cover: tx("Mbulim", "Cover"),
  col_received: tx("Pranuar", "Received"),
  col_value: tx("Vlera", "Value"),
  daysShort: tx("{days} ditë", "{days} days"),
  unknownReceipt: tx("e panjohur", "unknown"),
  never: tx("asnjëherë", "never"),
  thresholds: tx("Pragjet", "Thresholds"),
  lowStockThreshold: tx("Stok i ulët deri", "Low stock up to"),
  deadStockDays: tx("I ndenjur pas (ditë)", "Dead after (days)"),
  inventorySnapshot: tx("Gjendja aktuale — nuk varet nga periudha.", "Current snapshot — not affected by the period."),

  // ── Profitability ────────────────────────────────────────
  statementTitle: tx("Pasqyra e fitimit bruto", "Gross profit statement"),
  statementHint: tx(
    "Fitimi bruto nuk është fitimi neto i biznesit: shpenzimet operative (qiraja, pagat, postieri) nuk regjistrohen në sistem.",
    "Gross profit is not net business profit: operating expenses (rent, payroll, courier) are not recorded in the system."
  ),
  line_grossSales: tx("Shitjet bruto (çmimi i listës)", "Gross sales (list price)"),
  line_discounts: tx("− Zbritjet", "− Discounts"),
  line_revenue: tx("= Të ardhurat", "= Revenue"),
  line_refunds: tx("− Rimbursimet", "− Refunds"),
  line_netRevenue: tx("= Të ardhurat neto", "= Net revenue"),
  line_uncovered: tx("− Të ardhurat neto pa kosto (përjashtohen)", "− Net revenue without cost (excluded)"),
  line_coveredNet: tx("= Të ardhurat neto me kosto", "= Net revenue with cost"),
  line_cogsSold: tx("− Kostoja e mallit të shitur", "− Cost of goods sold"),
  line_cogsReturned: tx("+ Kostoja e mallit të kthyer në stok", "+ Cost of goods returned to stock"),
  line_grossProfit: tx("= Fitimi bruto", "= Gross profit"),
  line_grossMargin: tx("Marzhi bruto", "Gross margin"),
  netProfitUnavailable: tx("Fitimi neto i biznesit: nuk ka të dhëna", "Net business profit: not available"),
  netProfitUnavailableHint: tx("Kërkon shpenzimet operative, të cilat nuk regjistrohen.", "Requires operating expenses, which are not recorded."),
  deliveryFeesHint: tx("Tarifat e transportit të porosive të dorëzuara ({amount}) mbahen jashtë të ardhurave dhe marzhit.", "Delivery fees on delivered orders ({amount}) are kept out of revenue and margin."),
  profitTrend: tx("Fitimi bruto në kohë", "Gross profit over time"),
  profitByChannel: tx("Fitimi sipas kanalit", "Profit by channel"),
  profitByCategory: tx("Fitimi sipas kategorisë", "Profit by category"),
  topProfit: tx("Produktet më fitimprurëse", "Most profitable products"),
  lowestMargin: tx("Marzhi më i ulët", "Lowest margin"),
  missingCostCount: tx("{count} produkte me shitje nuk kanë kosto të plotë dhe nuk renditen.", "{count} selling products have incomplete cost and are not ranked."),
  costStatus_complete: tx("Kosto e plotë", "Complete cost"),
  costStatus_partial: tx("Kosto e pjesshme", "Partial cost"),
  costStatus_unavailable: tx("Pa kosto", "No cost"),
  costStatus_none: tx("Pa aktivitet", "No activity"),

  // ── Insights ─────────────────────────────────────────────
  insightsTitle: tx("Vëzhgime nga të dhënat", "Findings from your data"),
  insightsHint: tx(
    "Çdo vëzhgim llogaritet me rregulla fikse nga shitjet dhe stoku i periudhës — pa parashikime.",
    "Every finding is calculated with fixed rules from the period's sales and stock — no predictions."
  ),
  insightsEmpty: tx("Asgjë e pazakontë në këtë periudhë.", "Nothing unusual in this period."),
  evidence: tx("Të dhënat mbështetëse", "Supporting data"),
  rule: tx("Rregulli", "Rule"),
  severity_critical: tx("Kritike", "Critical"),
  severity_warning: tx("Kujdes", "Attention"),
  severity_positive: tx("Pozitive", "Positive"),
  severity_info: tx("Info", "Info"),
  insight_revenue_concentration: tx(
    "{productsFor80} nga {sellingProducts} produkte sjellin 80% të të ardhurave; 5 më të mirat sjellin {topShare}.",
    "{productsFor80} of {sellingProducts} products bring 80% of revenue; the top 5 bring {topShare}."
  ),
  insight_revenue_concentration_rule: tx("Shfaqet kur ka të paktën 5 produkte me shitje.", "Shown when at least 5 products sold."),
  insight_product_outperformer: tx("{count} produkt(e) sjellin secili të paktën {threshold} të të ardhurave neto.", "{count} product(s) each bring at least {threshold} of net revenue."),
  insight_product_outperformer_rule: tx("Pjesa e produktit ≥ {threshold} e të ardhurave neto.", "Product share ≥ {threshold} of net revenue."),
  insight_idle_inventory_value: tx(
    "{variants} variante ({units} copë, {retailValue} me çmim shitje) nuk po lëvizin — {share} e vlerës së stokut.",
    "{variants} variants ({units} units, {retailValue} at retail) are not moving — {share} of stock value."
  ),
  insight_idle_inventory_value_rule: tx("Variante me stok të ndenjur ose me lëvizje të ngadaltë.", "Variants flagged as dead or slow-moving stock."),
  insight_size_stockout_risk: tx("{sizes} numra po mbarojnë: stoku mjafton për ≤ {maxDaysOfCover} ditë.", "{sizes} sizes are running out: stock lasts ≤ {maxDaysOfCover} days."),
  insight_size_stockout_risk_rule: tx("Numri ka ≥ 3 copë të shitura në 30 ditë dhe stok për ≤ 14 ditë.", "Size sold ≥ 3 units in 30 days and has ≤ 14 days of stock."),
  insight_category_trend_up: tx("{count} kategori u rritën me më shumë se {threshold} krahasuar me periudhën e mëparshme.", "{count} categories grew by more than {threshold} versus the previous period."),
  insight_category_trend_down: tx("{count} kategori ranë me më shumë se {threshold} krahasuar me periudhën e mëparshme.", "{count} categories fell by more than {threshold} versus the previous period."),
  insight_category_trend_rule: tx("Ndryshim ≥ {threshold} dhe të paktën 100 € në njërën periudhë.", "Change ≥ {threshold} and at least €100 in either period."),
  insight_aov_change: tx("Vlera mesatare e shitjes ndryshoi {change}: nga {previous} në {current}.", "Average sale value changed {change}: from {previous} to {current}."),
  insight_aov_change_rule: tx("Ndryshim ≥ 10% me të paktën 5 shitje në të dyja periudhat.", "Change ≥ 10% with at least 5 sales in both periods."),
  insight_high_return_rate: tx("{count} produkte kthehen në të paktën {threshold} të copëve të shitura.", "{count} products come back for at least {threshold} of units sold."),
  insight_high_return_rate_rule: tx("Norma e kthimit ≥ {threshold}, me ≥ {minUnits} copë të shitura.", "Return rate ≥ {threshold}, with ≥ {minUnits} units sold."),
  insight_category_return_rate: tx("{count} kategori kanë normë kthimi të paktën {threshold}.", "{count} categories have a return rate of at least {threshold}."),
  insight_category_return_rate_rule: tx("Norma e kthimit ≥ {threshold}, me ≥ 3 copë të shitura.", "Return rate ≥ {threshold}, with ≥ 3 units sold."),
  insight_discount_share: tx("Zbritjet janë {discountRate} e shitjeve bruto ({discounts}).", "Discounts are {discountRate} of gross sales ({discounts})."),
  insight_discount_share_rule: tx("Norma e zbritjes ≥ 15%.", "Discount rate ≥ 15%."),
  ev_title: tx("Produkti", "Product"),
  ev_variant: tx("Varianti", "Variant"),
  ev_category: tx("Kategoria", "Category"),
  ev_size: tx("Numri", "Size"),
  ev_netRevenue: tx("Neto", "Net revenue"),
  ev_previousNetRevenue: tx("Periudha e kaluar", "Previous period"),
  ev_share: tx("Pjesa", "Share"),
  ev_change: tx("Ndryshimi", "Change"),
  ev_netUnits: tx("Copë neto", "Net units"),
  ev_onHand: tx("Në stok", "On hand"),
  ev_available: tx("Disponueshme", "Available"),
  ev_retailValue: tx("Vlera", "Retail value"),
  ev_daysSinceLastSale: tx("Ditë pa shitje", "Days without sale"),
  ev_status: tx("Gjendja", "Status"),
  ev_units30: tx("Shitur 30 ditë", "Sold 30 days"),
  ev_daysOfCover: tx("Ditë stok", "Days of stock"),
  ev_unitsSold: tx("Shitur", "Sold"),
  ev_unitsReturned: tx("Kthyer", "Returned"),
  ev_returnRate: tx("Norma", "Rate"),
  ev_period: tx("Periudha", "Period"),
  ev_averageOrderValue: tx("Vlera mesatare", "Average value"),
  ev_salesCount: tx("Shitje", "Sales"),
  ev_unitsPerTransaction: tx("Copë/shitje", "Units/sale"),
  ev_grossSales: tx("Shitjet bruto", "Gross sales"),
  ev_discounts: tx("Zbritjet", "Discounts"),
  ev_discountRate: tx("Norma", "Rate"),

  // ── Reports ──────────────────────────────────────────────
  reportsTitle: tx("Raportet", "Reports"),
  reportsHint: tx("Raporte të gatshme për printim ose PDF, dhe eksporte CSV me filtrat e njëjtë.", "Ready-to-print (or PDF) reports, and CSV exports with the same filters."),
  report_monthly: tx("Raporti mujor i performancës", "Monthly business performance"),
  report_monthly_hint: tx("KPI-të, kanalet, kategoritë, produktet kryesore dhe vëzhgimet për një muaj.", "KPIs, channels, categories, top products and findings for one month."),
  report_products: tx("Raporti i produkteve", "Product performance report"),
  report_products_hint: tx("Renditja e produkteve për periudhën e zgjedhur.", "Product ranking for the selected period."),
  report_inventory: tx("Raporti i gjendjes së stokut", "Inventory health report"),
  report_inventory_hint: tx("Vlera e stokut, rreziqet dhe stoku i ndenjur sot.", "Stock value, risks and dead stock today."),
  month: tx("Muaji", "Month"),
  print: tx("Printo", "Print"),
  openReport: tx("Hap raportin", "Open report"),
  closeReport: tx("Mbyll raportin", "Close report"),
  generatedAt: tx("Gjeneruar më {date}", "Generated on {date}"),
  exportsTitle: tx("Eksportet CSV", "CSV exports"),
  export_transactions: tx("Shitjet (çdo shitje)", "Sales (every sale)"),
  export_products: tx("Produktet", "Products"),
  export_variants: tx("Variantet", "Variants"),
  export_categories: tx("Kategoritë", "Categories"),
  export_inventory: tx("Stoku sipas variantit", "Stock by variant"),
  export_monthly: tx("Përmbledhja mujore", "Monthly summary"),
  monthlyTable: tx("Muaj pas muaji", "Month by month"),
  topProducts: tx("Produktet kryesore", "Top products"),
};

export default analyticsTranslations;
